import Alpine, { AlpineComponent } from 'alpinejs';
import { CatalogRules } from '../../types/form';
import { iodine } from '../../helpers/validation';
import { FormFieldValidationAlpine, getFieldValidation } from '../../helpers/fieldValidation';
import { scrollToAnchor } from '../../alpine/include/magics';

interface ContactFormAlpine extends AlpineComponent<Record<string, any>> {
    [key: string]: any;
    form: HTMLFormElement;
    init: () => void;
    validate: () => void;
    formatFieldOrderNumber: (orderInput: HTMLTextAreaElement, event: InputEvent) => void;
}

const rules: CatalogRules = {
    civility: ['truthy'],
    firstname: ['required'],
    lastname: ['required'],
    zip: ['required'],
    city: ['required'],
    phone: ['required', 'trybaPhone'],
    email: ['required', 'email', 'noPlusInEmail'],
};

document.addEventListener('alpine:init', () => {
    // @ts-ignore
    Alpine.data('initFormValidation', (form: HTMLFormElement): ContactFormAlpine & FormFieldValidationAlpine => {
        return {
            ...getFieldValidation(rules),
            ...{
                form,
                init(): void {
                    const catalogueSlug = new URLSearchParams(window.location.search).get('catalogue');
                    if (!catalogueSlug) return;

                    const checkbox = this.$refs[`whichCatalogs_${catalogueSlug}`] as HTMLInputElement | undefined;
                    if (!checkbox) return;

                    checkbox.checked = true;

                    // Sur mobile, la barre de menu qui recouvre le contenu est en position fixed,
                    // donc hors flux : scrollToAnchor() la mesure via <header>.getBoundingClientRect()
                    // qui vaut quasi 0 dans ce cas. On compense avec un offset manuel supplémentaire.
                    const offset = this.$store.global.isMobile ? 90 : 0;
                    scrollToAnchor('a-propos-de-vous', offset);
                },
                validate(): void {
                    this.errorMessages = [];
                    const firstname = this.$refs.firstname as HTMLInputElement;
                    const lastname = this.$refs.lastname as HTMLInputElement;
                    // as zip is in x-data=simpleAutocomplete, it is not accessible in refs any more
                    const zip = document.querySelector('[name$="[zip]"]') as HTMLInputElement;
                    const city = this.$refs.city as HTMLInputElement;
                    const phone = this.$refs.phone as HTMLInputElement;
                    const email = this.$refs.email as HTMLInputElement;
                    const civilityMadam = this.$refs.civility_madam as HTMLInputElement;
                    const civilitySir = this.$refs.civility_sir as HTMLInputElement;

                    const contactItems = {
                        firstname: firstname.value,
                        lastname: lastname.value,
                        zip: zip.value,
                        city: city.value,
                        phone: phone.value,
                        email: email.value,
                        civility: civilityMadam.checked || civilitySir.checked,
                    };

                    const contactRules = {
                        firstname: rules.firstname,
                        lastname: rules.lastname,
                        zip: rules.zip,
                        city: rules.city,
                        phone: rules.phone,
                        email: rules.email,
                        civility: rules.civility,
                    };

                    const validation = iodine.assert({ ...contactItems }, { ...contactRules });

                    const submitButton = form.querySelector('button[type=submit]') as HTMLButtonElement;
                    if (validation.valid) {
                        submitButton.disabled = true;
                        form.submit();
                    } else {
                        submitButton.disabled = false;
                        this.displayErrors(validation);
                    }
                },
                formatFieldOrderNumber(orderInput: HTMLTextAreaElement, event: InputEvent): void {
                    if (event.data && new RegExp(/^[a-zA-Z]+$/, 'g').test(event.data)) {
                        orderInput.value = '92';
                    }
                },
            },
        };
    });
});
